export default __webpack_public_path__ + "static/media/Hands_Green.ca4bfce8.png";